import { LOCALES } from '../constants';

const RTL_LOCALES = [LOCALES.HE];

export const isRTL = (locale?: string): boolean =>
  !!locale && RTL_LOCALES.includes(locale);
